import { useState, useMemo, useEffect, useRef } from 'react';
import Lottie from 'react-lottie';
import HeadTitle from '../head-title';
import Describe from '../describe';
import styles from './index.module.less';
import { getPageHeight, ifInView, ifOutView } from '@/utils';

const lastLottiePageIndex = 3;

const Page = ({ lottie, titleList, describeText, pageIndex, id }) => {
  const lottieEleWrap = useRef(null);
  const scrollEvent = useRef(null);
  const canSetLottieAnima = useRef(true);
  const canSetLottieTransAnima = useRef(true);
  const [lottieStop, setLottieStop] = useState(true);
  const [canLottieTransAnima, setCanLottieTransAnima] = useState(false);

  // lottie的动画
  useEffect(() => {
    // 每次进来解绑scroll
    window.removeEventListener('scroll', scrollEvent.current);
    scrollEvent.current = () => {
      if (canSetLottieAnima.current && ifInView(lottieEleWrap.current, true, 0.3) && lottieStop) {
        if (pageIndex === lastLottiePageIndex || ifInView(lottieEleWrap.current, true)) {
          canSetLottieAnima.current = false;
          setLottieStop(false);
        }
      }
      if (canSetLottieTransAnima.current && ifInView(lottieEleWrap.current, true, 0.33)) {
        canSetLottieTransAnima.current = false;
        setCanLottieTransAnima(true);
      }
      if (ifOutView(lottieEleWrap.current, true) && !lottieStop) {
        canSetLottieAnima.current = true;
        setLottieStop(true);
      }
    };
    scrollEvent.current();
    window.addEventListener('scroll', scrollEvent.current);

    return () => {
      window.removeEventListener('scroll', scrollEvent.current);
    };
  }, [lottieStop, pageIndex]);

  const defaultOptions = useMemo(
    () => ({
      loop: false,
      autoplay: false,
      animationData: lottie,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    }),
    [lottie],
  );

  return (
    <div style={{ height: getPageHeight() }} className={styles.block} id={id}>
      <div className={styles.head}>
        <HeadTitle titleList={titleList} />
        <Describe className={styles.describe} text={describeText} />
      </div>
      <div ref={lottieEleWrap} className={`${styles.lottie} ${canLottieTransAnima ? styles.transMoveUp : ''}`}>
        <Lottie options={defaultOptions} isStopped={lottieStop} isPaused={false} />
      </div>
    </div>
  );
};

export default Page;
